import $ from 'jquery';
import htmx from "htmx.org";


window.jQuery = $;
window.$ = $;

htmx.config.mode = "cors";
window.htmx = htmx


require('jquery-colorbox')
import 'jquery-colorbox/example1/colorbox.css'

require('superfish')

$(function () {
    $('ul.sf-menu').superfish({
        autoArrows: false  // disable generation of arrow mark-up, not working
    });
})